import axios from "axios";
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getCalendarNotes = async (q, filter_params, page, page_size, sort_by, sort_dir) => {

    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)

    const res = await axios.get(BACKEND_URL+'/calendar_notes', {
        params,
        withCredentials: true
    });
    return res;
}

export const createCalendarNote = async (createObj) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(BACKEND_URL+'/calendar_notes',
    createObj,
    {
        withCredentials: true,
        successMessage: "โน๊ตได้ถูกบันทึกแล้ว"
    });
    return res;
}

export const updateCalendarNote = async (id, updateObj) => {
    const res = await axios.put(BACKEND_URL+`/calendar_notes/${id}`,
    updateObj,
    {
        withCredentials: true,
        successMessage: "โน๊ตได้ถูกแก้ไขแล้ว"
    });
    return res;
}

export const deleteCalendarNote = async (id) => {
    const res = await axios.delete(BACKEND_URL+`/calendar_notes/${id}`,
    {
        withCredentials: true,
        successMessage: "โน๊ตได้ถูกลบแล้ว"
    });
    return res;
}
